import React from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Button,
    TextField,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell
} from '@mui/material';
import MemberGroupType from '../../../models/MemberGroupTypes'
import RestUtilities from '../../../services/RestUtilities';
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import MasterData from './MasterData'

const MemberGroups = (props: any) => {

    const TableColumns: string[] = ['ID', 'Bezeichnung', 'Beschreibung', 'Aktiv', 'Aktionen']


    let columns: JSX.Element[] = TableColumns.map(x => {

        return <TableCell key={x}>{x}</TableCell>
    })

    return (
        <>
            <h2 className='mt-3 title'>Stammdaten - Teilnehmergruppen</h2>
            <div className='card'>
                <div className='card-header'>
                    <h5>Filters</h5>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-sm-5'>
                            <TextField
                                label='Bezeichnung:'
                                name='name'
                                value={props.filter.name}
                                onChange={(e:any) => props.handleFilterChange(e)}
                                fullWidth></TextField>
                        </div>

                        <div className='col-sm-5'>
                            <TextField
                                label='Beschreibung:'
                                name='description'
                                value={props.filter.description}
                                onChange={(e:any) => props.handleFilterChange(e)}
                                fullWidth></TextField>
                        </div>
                    </div>
                    <div className='float-right mt-4'>
                        <Button 
                            variant='contained' 
                            color='primary' 
                            className='btnBlue' 
                            onClick={() => props.handleSearch()}
                        >
                        Suchen
                        </Button>
                        <Button
                            className='ml-2 btnBlue'
                            color='primary'
                            variant='contained'
                            onClick={() => props.clearFilters()}
                        >Zurücksetzen</Button>
                    </div>
                </div>
            </div>
            <div className='row mt-3 overflowTable'>
                <Table className="objects-table table">
                    <TableHead>
                        <TableRow>
                            {columns}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.rows}
                    </TableBody>
                </Table>
            </div>
            {
                !props.addNew &&
                <Button
                    className='mt-3 float-right btnBlue'
                    color='primary'
                    variant="contained"
                    onClick={() => {
                        props.changeMode('create')
                        props.showAddNew()
                    }}
                >Hinzufügen</Button>
            }
            {
                props.addNew &&
                <div className='row'>
                    <h4 className='col-sm-12'>Teilnehmergruppe bearbeiten:</h4>
                    <div className='col-sm-6'>
                        <TextField
                            value={props.newObject.groupName}
                            name='groupName'
                            label='Bezeichnung'
                            onChange={(e:any) => props.handleChangeNewObject(e)}
                            fullWidth />
                    </div>
                    <div className='col-sm-6'>
                        <TextField
                            value={props.newObject.groupDescription}
                            name='groupDescription'
                            label='Beschreibung'
                            onChange={(e:any) => props.handleChangeNewObject(e)}
                            fullWidth />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="outlined-aktiv">
                                Activ
                                    </InputLabel>
                            <Select
                                input={
                                    <OutlinedInput id='outlined-aktiv' fullWidth />
                                }
                                name='activ'
                                onChange={(e:any) => props.handleChangeNewObject(e)}
                                value={props.newObject.activ.toString()}
                                fullWidth
                            >
                                <MenuItem value={'true'}>Ja</MenuItem>
                                <MenuItem value={'false'}>Nein</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className='col-sm-4 offset-sm-8'>
                        <Button
                            className='mt-3 float-right btnBlue'
                            color='primary'
                            variant="contained"
                            onClick={() => props.submitNewObject()}>Speichern</Button>
                        <Button
                            className='mt-3 mr-2 float-right btnBlue'
                            color='primary'
                            variant="contained"
                            onClick={() => props.hideAddNew()}>Abbrechen</Button>
                    </div>
                </div>
            }
        </>
    )
}

export default MasterData<MemberGroupType, keyof MemberGroupType>(MemberGroups, MemberGroupType)